import { Button } from '../../lib/button.jsx';

function ComboboxMenuButton(
  props: Readonly<{
    selectedOptions: string[];
    options: { label: string; value: string; group?: string }[];
    onSelectAll: (e?: React.MouseEvent<HTMLButtonElement>) => void;
    onClearAll: (e?: React.MouseEvent<HTMLButtonElement>) => void;
    selectAllText?: string;
    clearAllText?: string;
  }>,
) {
  const {
    selectedOptions,
    options,
    onSelectAll,
    onClearAll,
    selectAllText,
    clearAllText,
  } = props;
  return (
    <>
      {selectedOptions.length !== options.length ? (
        <Button
          type="button"
          variant="plain"
          onClick={onSelectAll}
          className="mx-3 my-2 peer-first:hidden focus-visible:outline-action-focusBorder"
          data-dd-action-name="Select all button"
        >
          {selectAllText || 'Select all'}
        </Button>
      ) : (
        <Button
          type="button"
          variant="plain"
          onClick={onClearAll}
          className="mx-3 my-2 peer-first:hidden focus-visible:outline-action-focusBorder"
          data-dd-action-name="Clear all button"
        >
          {clearAllText || 'Clear all'}
        </Button>
      )}
    </>
  );
}

export default ComboboxMenuButton;
